import { render, staticRenderFns } from "./company-form-dialog.vue?vue&type=template&id=c4d10658"
import script from "./company-form-dialog.vue?vue&type=script&lang=js"
export * from "./company-form-dialog.vue?vue&type=script&lang=js"
import style0 from "./company-form-dialog.vue?vue&type=style&index=0&id=c4d10658&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports